"use strict";
/**
 * Announcement Type Definitions
 * Announcement feature for DFFiles (メンテナンス予告・障害通知・機能追加案内等)
 *
 * Requirements: 18.1, 18.1.1, 18.2, 18.3, 18.4
 *
 * NOTE: フロントとバックエンドの型不一致を防ぐため、API のリクエスト/レスポンス型を
 * この共有パッケージに集約する。管理画面・ユーザー画面で共通利用する表示定数
 * （カテゴリラベル・重要度バッジ）もここで定義する。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementValidation = exports.ANNOUNCEMENT_SEVERITY_BADGE = exports.ANNOUNCEMENT_SEVERITY_LABELS = exports.ANNOUNCEMENT_CATEGORY_LABELS = void 0;
// ============================================================================
// Display Constants (管理画面・ユーザー画面で共有)
// ============================================================================
/**
 * カテゴリ表示ラベル
 */
exports.ANNOUNCEMENT_CATEGORY_LABELS = {
    maintenance: 'メンテナンス',
    incident: '障害',
    feature: '機能追加',
    general: '一般',
};
/**
 * 重要度表示ラベル
 */
exports.ANNOUNCEMENT_SEVERITY_LABELS = {
    high: '重要',
    normal: '通常',
    low: '情報',
};
/**
 * 重要度バッジの表示設定（色スキーム）
 * color は design.md の重要度バッジ配色（high=赤/normal=青/low=グレー）に準拠。
 */
exports.ANNOUNCEMENT_SEVERITY_BADGE = {
    high: { label: '重要', color: 'red' },
    normal: { label: '通常', color: 'blue' },
    low: { label: '情報', color: 'gray' },
};
// ============================================================================
// Validation Rules (Constants)
// ============================================================================
/**
 * Announcement validation rules
 */
exports.AnnouncementValidation = {
    TITLE_MIN_LENGTH: 1,
    TITLE_MAX_LENGTH: 200,
    BODY_MIN_LENGTH: 1,
    BODY_MAX_LENGTH: 10000,
    ADDITIONAL_EMAILS_MAX: 500,
    DEFAULT_SEVERITY: 'normal',
    /** 公開終了日時未指定時のデフォルトオフセット（公開開始から90日後で公開中集合を有界化） */
    DEFAULT_PUBLISH_END_OFFSET_DAYS: 90,
    DEFAULT_PAGE_LIMIT: 20,
    MAX_PAGE_LIMIT: 100,
};
//# sourceMappingURL=announcement.js.map